import { type ReactNode } from 'react'
import { XCircle } from 'phosphor-react'
import * as AlertDialog from '@radix-ui/react-alert-dialog'
import clsx from 'clsx'

type AlertModalProps = {
  isOpen: boolean
  children: ReactNode
  onClose?: () => void
}

export const AlertModal = ({ isOpen, children, onClose }: AlertModalProps) => {
  return (
    <AlertDialog.Root open={isOpen}>
      <AlertDialog.Portal>
        <AlertDialog.Overlay className="absolute inset-0 z-50 bg-gray-500 bg-opacity-20" />
        <AlertDialog.Content
          className="fixed z-50 w-10/12 max-w-lg -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg top-1/4 left-1/2 "
        >
          <div
            className={clsx('flex items-center justify-between px-4 py-5')}
          >
            {onClose && (
              <button className="ml-auto" onClick={onClose}>
                <XCircle size={24} className="text-black" />
              </button>
            )}
          </div>

          <div>{children}</div>
        </AlertDialog.Content>
      </AlertDialog.Portal>
    </AlertDialog.Root>
  )
}
